import { View } from 'react-native';
const TabsHost = View;
export default TabsHost;
//# sourceMappingURL=TabsHost.js.map